import React, { useState, useEffect } from 'react';
import UserServices from '../../services/UserServices';
import CarServices from '../../services/CarServices';
function VendorUpdate({ vendor, closeModal, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loadingCities, setLoadingCities] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        businessName: '',
        state: '',
        city: '',
        address: '',
        cityName: '',
        stateName: '',
        pincode: '',
        image: '',
    });
    useEffect(() => {
        if (vendor) {
            setFormValues({
                name: vendor.name || '',
                email: vendor.email || '',
                businessName: vendor.businessName || '',
                address: vendor.address || '',
                cityName: vendor.cityName || '',
                state: vendor.state || '',   // ✅ state ID
                city: vendor.city || '',
                stateName: vendor.stateName || '',
                pincode: vendor.pincode || '',
                image: ''
            });
            if (vendor.image) {
     
                   setImagePreview(`${process.env.REACT_APP_URL}${vendor.image}`);
            }
        }
    }, [vendor]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // 🧠 Agar city change ho raha hai to cityName bhi update karo
        if (name === "city") {
            const selectedCity = cities.find(c => c._id === value);

            setFormValues(prev => ({
                ...prev,
                city: value,
                cityName: selectedCity?.name || ''
            }));
        }

        // 🧠 Agar state change ho raha hai to reset city + cityName
        else if (name === "state") {
            const selectedState = states.find(s => s._id === value);

            setFormValues(prev => ({
                ...prev,
                state: value,
                stateName: selectedState?.name || '',
                city: '',
                cityName: ''
            }));
        }

        else {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };



    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setImagePreview(reader.result);
            };

            reader.readAsDataURL(file);

            setFormValues(prev => ({
                ...prev,
                image: file
            }));
        }
    };



    useEffect(() => {
        CarServices.getState().then(res => {
            if (res.status) setStates(res.data);
        });
    }, []);

    // Fetch cities when state changes
    useEffect(() => {
        const fetchCities = async () => {
            if (formValues.state) {
                setLoadingCities(true);

                try {
                    const res = await CarServices.getCities(formValues.state);

                    if (res.status) {
                        setCities(res.data);

                        // ✅ CITY AUTO SELECT FIX
                        if (vendor?.cityName && !formValues.city) {
                            const matchedCity = res.data.find(
                                (c) => c.name === vendor.cityName
                            );

                            setFormValues(prev => ({
                                ...prev,
                                city: matchedCity?._id || ''
                            }));
                        }
                    }

                } catch (error) {
                    console.error(error);
                    setCities([]);
                } finally {
                    setLoadingCities(false);
                }
            }
        };

        fetchCities();
    }, [formValues.state]);
    useEffect(() => {
        if (vendor && states.length > 0) {

            const matchedState = states.find(
                (s) => s.name === vendor.stateName
            );

            setFormValues(prev => ({
                ...prev,
                state: matchedState?._id || ''
            }));
        }
    }, [vendor, states]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('name', formValues.name);
            formData.append('email', formValues.email);
            formData.append('businessName', formValues.businessName);
            formData.append('address', formValues.address);
            formData.append('cityName', formValues.cityName);
            formData.append('stateName', formValues.stateName);
            formData.append('pincode', formValues.pincode);
            formData.append('state', formValues.state);
            formData.append('city', formValues.city);
            if (formValues.image instanceof File) {
                formData.append("image", formValues.image);
            }

      const response= await UserServices.updateVendor(vendor?._id || vendor?.id, formData);

            // alert('Owner updated successfully!');

      if (response?.data) {
            alert(response.message);
             onSuccess?.();
        closeModal();
        } else {
            alert(response?.message);
        }

      

        } catch (error) {
            console.error('Update failed:', error);
            alert('Failed to update vendor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade edit-box show d-block" tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Owner</h5>
                        <button type="button" className="btn-close" onClick={closeModal} />
                    </div>

                    <div className="modal-body p-0">
                        <div className="container-box">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>

                                        <div className="input-field">
                                            <label>Name<span className=""></span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                placeholder='Name'
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>Email<span className=""></span></label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formValues.email}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                placeholder='Email'
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>Business Name<span className=""></span></label>
                                            <input
                                                type="text"
                                                name="businessName"
                                                value={formValues.businessName}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                
                                                placeholder='Business Name'
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>Address<span className=""></span></label>
                                            <input
                                                type="text"
                                                name="address"
                                                value={formValues.address}
                                                onChange={handleInputChange}
                                                className="form-control"
                                              
                                                placeholder='Address'
                                            />
                                        </div>
                                        {/* 
                                        <div className="input-field">
                                            <label>City<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="cityName"
                                                value={formValues.cityName}
                                                onChange={handleInputChange}
                                                className="form-control"
                                              
                                                placeholder='City'
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>State<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="stateName"
                                                value={formValues.stateName}
                                                onChange={handleInputChange}
                                                className="form-control"
                                        
                                                placeholder='State'
                                            />
                                        </div> */}
                                        <div className='col-lg-6'>
                                            <div className="input-field">
                                                <label>State</label>
                                                <select
                                                    name="state"
                                                    className="form-control"
                                                    value={formValues.state}
                                                    onChange={handleInputChange}

                                                >
                                                    <option value="">Select State</option>
                                                    {states.map(state => (
                                                        <option key={state._id} value={state._id}>
                                                            {state.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* City */}
                                        <div className='col-lg-6'>
                                            <div className="input-field">
                                                <label>City</label>
                                                <select
                                                    name="city"
                                                    className="form-control"
                                                    value={formValues.city}
                                                    onChange={handleInputChange}
                                                    disabled={!formValues.state || loadingCities}
                                                >
                                                    <option value="">
                                                        {loadingCities ? "Loading..." : "Select City"}
                                                    </option>
                                                    {cities.map(city => (
                                                        <option key={city._id} value={city._id}>
                                                            {city.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="input-field">
                                            <label>Pincode<span className=""></span></label>
                                            <input
                                                type="text"
                                                name="pincode"
                                                value={formValues.pincode}
                                                onChange={handleInputChange}
                                                className="form-control"
                                            
                                                maxLength="6"
                                                placeholder='Pincode'
                                            />
                                        </div>
                                        <div className="col-lg-6 col-sm-12">
                                            <div className="input-field">
                                                <label>Image</label>

                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleImageChange}

                                                />

                                                {imagePreview && (
                                                    <img
                                                        src={imagePreview}
                                                        alt="preview"
                                                        style={{ width: "100px", marginTop: "10px", borderRadius: "6px" }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="submit-green-btn"
                                            disabled={loading}
                                        >
                                            {loading ? "Updating..." : "UPDATE VENDOR"}
                                        </button>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorUpdate;